import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';
import PickupRequestsAdminList from '../../components/system/PickupRequestsAdmin/PickupRequestsAdminList';
import PickupRequestsAdminHeader from '../../components/system/PickupRequestsAdmin/PickupRequestsAdminHeader';
import PickupRequestsAdminFilter from '../../components/system/PickupRequestsAdmin/PickupRequestsAdminFilter';

import { useSessionContext } from '../../contexts/SessionContext';

export default function PickupRequestsAdminPage( props ){
    //console.debug("RTS Break PickupRequestAdminPage");

    const {curFilter, user, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [data, setData] = useState([]);
    const [filter, setFilter] = useState();   


    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/PickupRequest/GetPickupRequestsSummary";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
            }
            setIsLoading(false);
            setHasError(false);
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]);
    

    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'PickupRequestsAdminPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({user:user, customer:null, status:75, sortBy:0});
            fetchData({user:user, customer:null, status:75, sortBy:0})
        }
    }, [props, user, sessionCustomer, curFilter, fetchData]); 


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    }; 

    
    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };


    return(
        <Box>
            <PickupRequestsAdminHeader />
            <PickupRequestsAdminFilter filter={filter} setFilterFx={setFilter} />
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <PickupRequestsAdminList data={data} />
            </Box>
        </Box>
    );

}
